module.exports = __webpack_public_path__ + "static/media/plane-path-reskil.6a25be61.svg";